var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("custom-select", {
    ref: "vselect",
    attrs: {
      options: _vm.selectOptions,
      "on-change": _vm.onChange,
      clearSearchOnSelect: true,
      value: _vm.selectedOption,
      loading: _vm.loading,
      disabled: _vm.disabled,
      selectOnTab: true
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec065840", { render: render, staticRenderFns: staticRenderFns })
  }
}